import { uniqBy } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Total } from 'core/elements';
import { NumberHelper } from 'core/helpers';
import { useAgGridClientTableContext } from 'core/states';
import { IPartInventoryItem } from 'parts/types';
import { sumQuantityAvailable } from 'parts/utils';

import { getLocationKey } from './utils';

const STATUS_PANEL_CLASS = 'ag-status-name-value ag-status-panel pf-bold-totals';

export const VendorTotalsStatusBar = () => {
  const { t } = useTranslation();

  const { rows } = useAgGridClientTableContext();

  const total = useMemo(() => {
    const uniqueRecords = uniqBy(rows as IPartInventoryItem[], getLocationKey);
    const value = sumQuantityAvailable(uniqueRecords);

    return value ? NumberHelper.format({ amount: value }) : undefined;
  }, [rows]);

  return (
    <Total
      label={t('headerAvailable')}
      value={total}
      options={{ classNames: STATUS_PANEL_CLASS }}
    />
  );
};
